import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/break-time`

export default {
  available() {
    return Client.get(`${resource}/available`)
  },
  enable() {
    return Client.put(`${resource}/enable`)
  },
  update(id, payload) {
    return Client.put(`${resource}/update-role/${id}`, payload)
  },
  resume() {
    return Client.put(`${resource}/resume`)
  },
}
